module.exports = __webpack_public_path__ + "static/media/ons.cca1cc44.png";